const French = {
  "Yesterday with": "Subhas",
  'and': '123',
  'concert in LA. Was  totally fantastic! People were really excited about  this one!': '.....................................................',
  '#MotivationMonday': '#MotivationMonday',
  '#Morning': '#Morning',
  "Reference site about Lorem Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.": "111111111111111111111111111111111111111111111111111386423786429846289764987264987394785693748597834y59783495",
  "English(en)": "Spanish(es)",
  "Announcements": "Inglés",
  "Featured Posts": "Anuncios",
  "Action Required": "Publicaciones destacadas",
  "more liked this": "Acción requerida",
  "Comments": "A más le gusta esto",
  "Awards": "Comentarios",
  "Upcoming Birthdays": "Premios",
  "Upcoming Work-Anniversaries": "Cumpleaños próximos",
  "Popular Posts": "Próximos Aniversarios de Trabajo",
  "Upcoming Wedding Anniversaries": "entradas populares",
  "Reference site about lorem ipsum, giving information": "Próximos aniversarios de boda",
  "Follow Up Suggestions": "Sitio de referencia sobre lorem ipsum, dando información..",
  "Feed": "Sugerencias de seguimiento",
  "Post": "Alimentar",
  "My Feeds": "Correo",
  "Feed Detail": "Mis feeds",
  "Featured": "Detalle de alimentación",
  "Pop. Posts": "Presentado",
  "Apply": "Estallido. Publicaciones",
  "Team Leaves": "Aplicar",
  "My Leaves": "El equipo se va",
  "Hello": "mis hojas",
  "Leave Ledger": "Hola",
  "Org Leaves": "Dejar libro mayor",
  "Employees": "Hojas de organización",
  "All Teams": "Empleados",
  "My Team": "Todos los equipos",
  "Log Out": "Mi equipo",
  "Awards": "Cerrar sesión",
  "Quick Actions": "Premios",
  "Ticket Management": "Acciones Rápidas",
  "Ticket Detail": "Gestión de entradas",
  "My Tickets": "Detalle del billete",
  "Add Ticket": "Mis entradas",
  "Ticket Detail": "Agregar boleto",
  "Leave": "Detalle del billete",
  "Apply": "Dejar",
  "My Leaves": "Aplicar",
  "Team Leaves": "mis hojas",
  "Org Leaves": "El equipo se va",
  "Leave Ledger": "Hojas de organización",
  "My Leave Completed Leave": "Dejar libro mayor",
  "Gallery": "Mi licencia Licencia completa",
  "Single Gallery": "Galería",
  "Add Media": "Galería única",
  "Hr Assessment": "Agregar medios",
  "My Assessment": "Evaluación de recursos humanos",
  "EmployeeAssessment": "Mi evaluación",
  "Hr Assessment": "Evaluación de empleados",
  "Recruitment": "Evaluación de recursos humanos",
  "Recruitment Dashboard": "Reclutamiento",
  "Recruitment Details": "Panel de reclutamiento",
  "Create Position": "Detalles de reclutamiento",
  "Applicant Details": "Crear posición",
  "Add Applicant": "Detalles del Aplicante",
  "Applicant Search": "Agregar solicitante",
  "Work From Home": "Búsqueda de solicitantes",
  "Work From Home Dashboard": "Trabajar desde casa",
  "My Work From Home": "Panel de trabajo desde casa",
  "Team Work From Home": "Mi trabajo desde casa",
  "Completed": "Trabajo en equipo desde casa",
  "Pending": "Terminado",
  "More": "Pendiente",
  "Communication Panel": "Más",
  "Create Reminders": "Panel de comunicación",
  "Reminders": "Crear recordatorios",
  "First time dashboard": "Recordatorios",
  "Audit Trails": "Panel de control por primera vez",
  "Create Owner Page": "Pistas de auditoría",
  "Account Owner Page": "Crear página de propietario",
  "Change Password": "Página del propietario de la cuenta",
  "OTP Verification": "Cambiar la contraseña",
  "Policy": "Verificación OTP",
  "AddPolicy": "Política",
  "Policies": "Agregar política",
  "Policydetail": "Políticas",
  "All Teams": "Detalle de la póliza",
  "My Teams": "Todos los equipos",
  "New": "Mis equipos",
  "Self Learning": "Nuevo",
  "Instructor Training": "Auto aprendizaje",
  "Task Management": "Formación de instructores",
  "Task Detail": "Administración de tareas",
  "Search": "Detalle de la tarea",
  "Search Result": "Buscar",
  "What would you like to search": "Resultado de búsqueda",
  "Search Employee & their post": "¿Qué te gustaría buscar?",
  "Profile": "Buscar empleado y su publicación",
  "Change password": "Perfil",
  "Send Us Feedback": "Cambiar la contraseña",
  "2022 © OrgGenie - Your Organization Portal. Powered By": "Envianos tus comentarios",
  "BizBrolly": "2022 © OrgGenie - El portal de su organización. Energizado por",
  "Version 16.6": "BizBrolly",
  "Log Out": "Versión 16.6",
  "Add App": "Cerrar sesión",
  "App Title": "Agregar aplicación",
  "Links": "Título de la aplicación",
  "Existing App": "Enlaces",
  "Apps": "Aplicación existente",
  "Decline": "Aplicaciones",
  "Save": "Rechazar",


};

export default French;
